import { formatNumber } from '../../../helpers';
type Props = {
  saldo: string;
  disponible: string;
  porcentage: number;
};

const ProgressGraphicData = ({ saldo, disponible, porcentage }: Props) => {
  return (
    <div className="card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end bg-opacity-0 mt-5">
      <div className="py-0 ms-7">
        <div className="fw-bolder fs-7 m-0">{saldo}</div>
      </div>
      <div className="card-body d-flex align-items-center pt-0">
        {/* Ícono de servicio */}
        <div className="pe-5 d-flex flex-column align-items-center justify-content-center">
          <i className="fab fa-spotify" style={{ fontSize: '50px' }} />
        </div>

        {/* Contenido de la gráfica */}
        <div className="d-flex align-items-center flex-column mt-3 w-100">
          <div className="row w-100 mt-5">
            <div className="col-6 text-start m-0 p-0">
              <div className="mb-1">
                <label className="fw-bolder text-muted">Disponible</label>
                <div className="fw-bolder text-primary">
                  {formatNumber(Number(disponible))} MB
                </div>
              </div>
            </div>
          </div>
          <div
            className="h-8px mx-3 w-100 rounded mb-4"
            style={{ backgroundColor: '#D6FFEB' }}
          >
            <div
              className="bg-primary rounded h-8px"
              role="progressbar"
              style={{ width: `${porcentage}%` }}
              aria-valuenow={porcentage}
              aria-valuemin={0}
              aria-valuemax={100}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export { ProgressGraphicData };
